angular.module('impactx.catalog').controller('CatalogRuleSystemListCtrl', CatalogRuleSystemListCtrl);
CatalogRuleSystemListCtrl.$inject = ['CatalogRuleService', 'selectedListItems'];

function CatalogRuleSystemListCtrl(CatalogRuleService, selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'CatalogRule'
        },
        {
            label: "deactivate",
            action: toggleStatus,
            condition: canDeactivate,
            process: 'CatalogRule'
        },
        {
            label: "activate",
            action: toggleStatus,
            condition: canActivate,
            process: 'CatalogRule'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/catalog/rules/templates/catalog.rule.system.list.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/catalog/rule/system/list',
        ctrl: this,
        id: "CatalogRuleSystemList",
        mainAction: {id: "new", link: "#/catalogruledetail/0/0", icon: "mdi-plus"},
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function toggleStatus () {
        CatalogRuleService.toggleStatus(selectedListItems.getFirstSelectedId());
    }

    function canActivate() {
        var item = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection() && item.StatusValue == 2 && !item.readOnly.value && !item.deleted;
    }

    function canDeactivate() {
        var item = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection() && item.StatusValue == 1 && !item.readOnly.value && !item.deleted;
    }

    function getDetailLink() {
        return "catalogruledetail/" + selectedListItems.getFirstSelectedId() + "/0";
    }
}